import type { IconProps } from './../../models/icon';

export function LinkIcon({
  width = 24,
  height = 24,
  secondaryColor = 'var(--color-200)',
  className = '',
}: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      width={width}
      height={height}
      className={className}
    >
      <g clipPath="url(#a)">
        <path
          fill={secondaryColor}
          d="M0.856934 7.71429C0.856934 6.76752 1.62444 6 2.57122 6H16.2855C17.2323 6 17.9998 6.76752 17.9998 7.71429V21.4286C17.9998 22.3754 17.2323 23.1429 16.2855 23.1429H2.57122C1.62445 23.1429 0.856934 22.3754 0.856934 21.4286V7.71429Z"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
          d="M17.9998 13.7143V21.4286C17.9998 21.8832 17.8191 22.3193 17.4977 22.6407C17.1762 22.9622 16.7402 23.1429 16.2855 23.1429H2.57122C2.11656 23.1429 1.68053 22.9622 1.35904 22.6407C1.03755 22.3193 0.856934 21.8832 0.856934 21.4286V7.71429C0.856934 7.25962 1.03755 6.82359 1.35904 6.5021C1.68053 6.18062 2.11656 6 2.57122 6H10.2855"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
          d="M17.1431 0.857178H23.1431V6.85718"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
          d="M23.1429 0.857178L13.7144 10.2857"
        />
      </g>
    </svg>
  );
}
